import { createContext, useContext } from "react";

export const RoomBookUpgradeBundlesContext = createContext({});
export const useRoomBookUpgradeBundlesContext = () => {
  return useContext(RoomBookUpgradeBundlesContext);
};
